// Solo valores publicables. Todo lo `REACT_APP_*` termina en el JS público del
// sitio: acá NUNCA va un secreto (API secrets, client secrets, tokens de
// management). Las subidas a Cloudinary se firman en el servidor
// (`POST /pictures/sign`, ver utils/cloudinary.js).
export const cloud_name = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
export const api_key_paypal = process.env.REACT_APP_PAYPAL_KEY;
export const tracking_id = process.env.REACT_APP_TRACKING_ID;
